// const ImageURL = "http://localhost/photogallery/public"
const ImageURL = "https://albums.frameophotography.in/backend/public"
export default ImageURL;